class Navigation {
  constructor(lenis) {
    this.lenis = lenis
    this.navigation = document.getElementById('js-main-navigation')
    if (!this.navigation) return
    this.menuButton = document.getElementById('js-menu-button')
    this.listItems = this.navigation?.querySelectorAll('li')
    this.animationTimeout = null
    this.readyTimeout = null
    this.events()
    this.setupIndexes()
  }

  // Setup indexes for the list item animations
  setupIndexes() {
    if (!this.listItems) return
    this.listItems.forEach((li, index) => {
      li.style.setProperty('--index', index)
    })
  }

  events() {    
    const navigationButtons = this.navigation.querySelectorAll('button')
    
    if (navigationButtons.length) {
      navigationButtons.forEach(button => {
        button.addEventListener('click', this.handleNavigationButtonClick.bind(this))
      })
    }

    const scrollTriggers = document.querySelectorAll('.js-scroll-trigger')

    if (scrollTriggers.length) {
      scrollTriggers.forEach(trigger => {
        trigger.addEventListener('click', this.handleNavigationButtonClick.bind(this))
      })
    }

    this.menuButton.addEventListener('click', this.toggleMenu.bind(this))
    
    // Close menu on ESC key press
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.navigation.classList.contains('is-active')) {
      this.closeMenu()
    }
  }

  // Smooth scroll to the section
  handleNavigationButtonClick(event) {
    event.preventDefault()
    const section = event.currentTarget.dataset.section
    const sectionElement = document.getElementById(section)
    if (!sectionElement) return
    const targetScroll = sectionElement.getBoundingClientRect().top + (window.scrollY || window.pageYOffset)
    if (this.lenis) {
      this.lenis.scrollTo(targetScroll, { duration: 1.2 })
    } else {
      sectionElement.scrollIntoView({ behavior: 'smooth' })
    }
    this.closeMenu()
  }

  openMenu() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout)
      this.animationTimeout = null
    }

    // Additional classes to control the animation
    this.navigation.classList.remove('is-ready', 'is-closing')
    this.navigation.classList.add('is-active')

    if (this.readyTimeout) clearTimeout(this.readyTimeout)
    const openDuration = 600 + (this.listItems.length - 1) * 50
    this.readyTimeout = setTimeout(() => {
      this.readyTimeout = null
      this.navigation.classList.add('is-ready')
    }, openDuration)

    this.menuButton.classList.add('is-active')
    this.menuButton.setAttribute('aria-expanded', 'true')
    this.menuButton.setAttribute('aria-label', 'Close navigation menu')
  }

  closeMenu() {
    this.navigation.classList.add('is-closing')
    this.navigation.classList.remove('is-active', 'is-ready')
    if (this.readyTimeout) {
      clearTimeout(this.readyTimeout)
      this.readyTimeout = null
    }

    // Additional timeout to control the animation
    if (this.animationTimeout) clearTimeout(this.animationTimeout)
    this.animationTimeout = setTimeout(() => {
      this.animationTimeout = null
      this.navigation.classList.remove('is-closing')
    }, 900)

    this.menuButton.classList.remove('is-active')
    this.menuButton.setAttribute('aria-expanded', 'false')
    this.menuButton.setAttribute('aria-label', 'Open navigation menu')
  }

  toggleMenu() {
    if (this.navigation.classList.contains('is-active')) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }
}

export default Navigation